import { Location } from '../../../domain/location';

export const locationLabel = (location: Location) =>
  `${location.collectionName ? `${location.collectionName}/` : ''}${location.name}`;

export function locationOptions(locations: Location[]) {
  const groupKey = (location: Location) =>
    JSON.stringify([location.collectionId || null]);
  const groups = new Map(
    locations.map((location) => [
      groupKey(location),
      location.collectionName || location.collectionId || 'Other locations',
    ]),
  );
  const groupBy = groups.size > 1 ? groupKey : undefined;
  return {
    groupBy,
    getGroupLabel: (key: string) => groups.get(key) || key,
    options: [...locations].sort(
      (a, b) =>
        (groupBy
          ? (groups.get(groupKey(a)) || '').localeCompare(
              groups.get(groupKey(b)) || '',
            ) || groupKey(a).localeCompare(groupKey(b))
          : 0) || a.name.localeCompare(b.name),
    ),
  };
}
